import * as React from 'react';
import styles from './index.less';
import { Dropdown } from 'antd';
import FIcons from '@/components/FIcons';
import { FUtil } from '@freelog/tools-lib';
import FSimpleBar from '../FSimpleBar';

interface FDropdown2Props extends React.ComponentProps<typeof Dropdown> {
  // childrenText?: string;
  autoArrow?: boolean;
  // arrowStyle?: React.CSSProperties;
}

function FDropdown2({
  overlayClassName,
  children,
  onOpenChange,
  autoArrow,
  // arrowStyle = {},
  menu,
  overlay,
  overlayStyle,
  ...props
}: FDropdown2Props) {
  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(false);
  const dropdownProps = { ...props } as Record<string, unknown>;
  delete dropdownProps.overlay;
  delete dropdownProps.overlayStyle;

  return (
    <Dropdown
      // open={true}
      {...dropdownProps}
      overlayClassName={[styles.Dropdown_OverlayClassName, overlayClassName].join(' ')}
      onOpenChange={(open: boolean) => {
        // console.log(open, 'open asd8fiuj;iaosjd;flkjlks;djfkl;jlk;');
        set$open(open);
        onOpenChange?.(open);
        // debugger;
      }}
      menu={{
        ...menu,
        onClick: (value) => {
          // console.log(value, 'value asd8fiuj;iaosjd;flkjlks;djfkl;jlk;');
          menu?.onClick?.(value);
          set$open(false);
          onOpenChange?.(false);
        },
      }}
      // open={true}
      popupRender={(originNode) => {
        return (
          <FSimpleBar maxHeight={460} className={styles.Dropdown_PopupRender}>
            {originNode}
          </FSimpleBar>
        );
      }}
    >
      {autoArrow ? (
        <div className={styles.Dropdown_ChildrenText}>
          {children}{' '}
          <FIcons.FArrow
            style={{
              fontSize: 12,
              // ...arrowStyle
            }}
            direction={$open ? 'up' : 'down'}
          />
        </div>
      ) : (
        children
      )}
    </Dropdown>
  );
}

export default FDropdown2;
